import { RootState } from '@beam-app/types';
import {
  GlobalEquipment,
  EquipmentTypeKeepNulls,
} from '@pages/Products/components/OnBoardingModal/types';
import { LambdaTags } from '@pages/Products/components/OnBoardingModal/helpers/PatchMassEditLambda';

import { EquipmentsMap } from './equipmentsPicker.schema';

export type EditActions =
  | {
      type: 'SAVE';
    }
  | {
      type: 'CLOSE';
      kind: 'CLOSE' | 'CLOSE-ADDMORE';
    };

interface Context {
  actionQueue: EditActions[];
  equipments: EquipmentsMap;
  isDirty: boolean;
  terminateReason: TERMINATE_REASON;
}
export type TERMINATE_REASON = null | 'ADD-MORE';
export type Events =
  | { type: 'SAVE-FIRST' }
  | { type: 'ABORT' }
  | {
      type: 'SAVE';
    }
  | {
      type: 'SUCCESS';
      values: Partial<EquipmentTypeKeepNulls>[] | Partial<GlobalEquipment>;
      knownData: RootState['knownData'];
      tagsDiff?: LambdaTags;
    }
  | { type: 'DIRTY'; isDirty: boolean }
  | {
      type: 'TERMINATE';
      reason: TERMINATE_REASON;
      isSaving: boolean;
    }
  | {
      type: 'FORCE-TERMINATE';
      reason: TERMINATE_REASON;
    }
  | {
      type: 'SAVE-THEN-CLOSE';
      reason: TERMINATE_REASON;
    }
  | { type: 'ERROR' };
export const MassEditSchemaValue = {
  context: {} as Context,
  events: {} as Events,
};
export type { Context as MassEditContext, Events as MassEditEvents };
